module.exports = __webpack_public_path__ + "static/media/no_post_icon.2b256e6a.svg";